import { connect } from 'react-redux';
import { DnsSearchComponent } from '../../components';
import { searchDomainsRecord, getDomains } from '../../redux/actions/dns';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

const recordTypes = ['TXT', 'A', 'MX', 'NS', 'CNAME', 'SRV', 'AAAA'].map(value => ({ value, text: value, key: value }));

const mapStateToProps = state => {
 
 return {
    dnsSearchResult: state.dns.dnsSearchResult,
  }
}

const mapDispatchToProps = { searchDomainsRecord, getDomains, push }

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DnsSearchComponent));


// WEBPACK FOOTER //
// ./src/containers/DnsSearch/DnsSearch.js